<template>
    <div>
        <!-- banner -->
        <div class="banner_top_big">
            <headerNew></headerNew>
            <div class="top_box">
                <div class="banner_box">
                    <el-carousel :autoplay-speed="4000" :interval="4000" trigger="click" autoplay>
                        <el-carousel-item>
                            <div class="first_banner">
                                <div class="first_width">
                                    <div class="first_left">
                                        <div>
                                            <p class="banner_po">让版权实现更大价值</p>
                                            <p class="banner_pt">开通会员，尊享一站式版权服务</p>
                                            <p class="banner_pr">存证  /  登记  /  取证  /  监测  /  公证  /  版权区块链</p>
                                            <a class="banner_btn" @click="goXu" v-if="vipFlag && vipFlag == 1">VIP续费</a>
                                            <a class="banner_btn" @click="openVip" v-else>开通VIP</a>
                                        </div>
                                        <img src="./images/fireCNew.png"/>
                                    </div>
                                    <img src="./images/indexBanner.png" alt='版权登记' style="width:100%;" class="dabanner"/>
                                    <!-- <img src="./images/newBanner.png" alt='版权登记' style="width:100%;" class="dabanner"/> -->
                                </div>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
            <!-- banner下的确权框 -->
            <div class="banner_btm_box">
                <div class="banner_btm_flex">
                    <p class="banner_btm_flex_tit">
                        <img src='./images/bqIcon.png'/>
                        <span>版权确权</span>
                    </p>
                    <ul>
                        <li>
                            <p class="list_tit">版权存证</p>
                            <p class="list_txt"><span @click="lijiCz">版权存证（版权区块链存证）</span></p>
                        </li>
                        <li>
                            <p class="list_tit">版权登记</p>
                            <p class="list_txt">
                                <span @click="lijiDci">美术作品登记</span>|
                                <span @click="lijiDci" style="margin-left:14px">美术作品登记加急</span><br/>
                                <span @click="lijiDci">文字作品登记</span>|
                                <span @click="lijiDci" style="margin-left:14px">文字作品登记加急</span>|
                                <span @click="lijiDci" style="margin-left:14px">音乐作品登记</span><br/>
                                <span @click="lijiDci">电影作品登记</span>|
                                <span @click="lijiDci" style="margin-left:14px">汇编作品登记</span>
                            </p>
                        </li>
                    </ul>
                </div>
                <div class="banner_btm_flex">
                    <p class="banner_btm_flex_tit">
                        <img src='./images/wqIcon.png'/>
                        <span>版权维权</span>
                    </p>
                    <ul>
                        <li>
                            <p class="list_tit">版权监测</p>
                            <p class="list_txt">
                                <span @click="goMonitor">图片监测</span>|
                                <span style="margin-left:14px" @click="goMonitor">文字监测</span>|
                                <span style="margin-left:14px" @click="goMonitor">音乐监测</span>|
                                <span style="margin-left:14px" @click="goMonitor">电商监测</span><br/>
                                <span @click="goMonitor">公众号监测</span>
                            </p>
                        </li>
                        <li>
                            <p class="list_tit">法律服务</p>
                            <p class="list_txt"><span @click="zixunLs">免费问律师</span></p>
                        </li>
                    </ul>
                </div>
                <div class="banner_btm_flex">
                    <p class="banner_btm_flex_tit">
                        <img src='./images/qqIcon.png'/>
                        <span>侵权取证</span>
                    </p>
                    <ul>
                        <li>
                            <p class="list_tit">电脑端取证</p>
                            <p class="list_txt">
                                <span @click="evidenceWeb">网页取证</span>|
                                <span @click="gcquzheng" style="margin-left:14px">过程录屏取证</span>
                            </p>
                        </li>
                        <li>
                            <p class="list_tit">手机端取证</p>
                            <p class="list_txt">
                                <span @click="downLoadQzb">录音取证</span>|
                                <span @click="downLoadQzb" style="margin-left:14px">拍照取证</span>|
                                <span @click="downLoadQzb" style="margin-left:14px">录像取证</span>|
                                <span @click="downLoadQzb" style="margin-left:14px">录屏取证</span>
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 荣誉资质 -->
        <div  class="ryzz_box_big">
            <div class="ryzz_box">
                <p class="ryzz_box_left">
                    <img src='./images/ryzz.png'/>
                    <span>荣誉资质</span>
                </p>
                <ul class="ryzz_box_right">
                    <li style="margin-top: 5px;width:31%">
                        <img src="./images/ryzz_list.png"/>
                        <span>安妮股份（002235.SZ）全资子公司</span>
                    </li>
                    <li style="margin-top: 5px;width:35%">
                        <img src="./images/ryzz_list.png"/>
                        <span>版权保护中心/互联网法院/国家授时中心合作伙伴</span>
                    </li>
                    <li style="margin-top: 5px;width:33%">
                        <img src="./images/ryzz_list.png"/>
                        <span>中国版权保护中心联合创新实验室共建方</span>
                    </li>
                    <li style="width:31%">
                        <img src="./images/ryzz_list.png"/>
                        <span>版权区块链联盟主要发起单位及理事长单位</span>
                    </li>
                    <li style="width:35%">
                        <img src="./images/ryzz_list.png"/>
                        <span>中国区块链技术和产业发展论坛副理事长单位</span>
                    </li>
                    <li style="width:33%">
                        <img src="./images/ryzz_list.png"/>
                        <span>中国反侵权假冒创新战略联盟联席理事长单位</span>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 版权存证 -->
        <div class="cz_box" style="">
            <img src='./images/czzsnew.gif' class="cz_zhengshu"/>
            <div class="cz_right">
                <p class="cz_right_tit">版权存证</p>
                <p class="cz_right_t">作品的“出生证”，创作完成第一时间存证可有效证明作品的诞生时间和权属</p>
                <ul class="cz_right_list">
                    <li>
                        <img src='./images/gxbj.png'/>
                        <span>高效便捷</span>
                        <span>创作即确权</span>
                    </li>
                    <li>
                        <img src='./images/sfrk.png'/>
                        <span>司法认可</span>
                        <span>打造完整证据链<br/>维权无忧</span>
                    </li>
                    <li>
                        <img src='./images/gxjb.png'/>
                        <span>高性价比</span>
                        <span>高品质服务，行业低价</span>
                    </li>
                    <li>
                        <img src='./images/qkljs.png'/>
                        <span>区块链技术</span>
                        <span>直通互联网法院<br/>证据不被篡改</span>
                    </li>
                </ul>
                <div class="cz_right_btn">
                    <a @click="lijiCz" class="yellow">
                        立即存证
                        <span></span>
                        <!-- <img src='./images/go.png'/> -->
                    </a>
                    <a style="margin-left:24px" @click="lookCzDetail" class="normal">
                        查看详情
                        <span></span>
                        <!-- <img src='./images/go.png'/> -->
                    </a>
                </div>
            </div>
        </div>
        <!-- 版权登记 -->
        <div class="dci_all">
            <div class="dci_bigbox">
                <div class="cz_box">
                    <div class="cz_right">
                        <p class="cz_right_tit" style="color:#FFFFFF">版权登记</p>
                        <p class="cz_right_t" style="color:#FFFFFF">作品的“身份证”，由版权局颁发，版权专家全程护航，安心出证</p>
                        <ul class="cz_right_list">
                            <li>
                                <img src='./images/ksxz.png'/>
                                <span style="color:#F5F5F5">快速下证</span>
                                <span style="color:#BDBDBD">最快一个工作日完成</span>
                            </li>
                            <li>
                                <img src='./images/jywy.png'/>
                                <span style="color:#F5F5F5">交易无忧</span>
                                <span style="color:#BDBDBD">不通过全额退款</span>
                            </li>
                            <li>
                                <img src='./images/zysxt.png'/>
                                <span style="color:#F5F5F5">专业省心</span>
                                <span style="color:#BDBDBD">版权专家全流程服务</span>
                            </li>
                            <li>
                                <img src='./images/tmbj.png'/>
                                <span style="color:#F5F5F5">透明便捷</span>
                                <span style="color:#BDBDBD">统一价格，全线上操作</span>
                            </li>
                        </ul>
                        <div class="dci_right_btn">
                            <a style="float:left;margin-right:25px" class="yellow">
                                <span @click="lijiDci">立即登记</span>
                                <i></i>
                                <!-- <img src='./images/dci_go.png'/> -->
                            </a>
                            <!--<a style="margin-left:24px">
                                <span @click="lookDciDetail">查看详情</span>
                                <img src='./images/dci_go.png'/>
                            </a>-->
                        </div>
                    </div>
                    <img src='./images/dci_zhengshu.gif' class="dci_zhengshu"/>
                </div>
            </div>
            <div class="fwlc_box">
                <h2>服务流程</h2>
                <ul>
                    <li class="dci_cont">
                        <p><img src="./images/smrz.png" style="width:31px;height:26px"/></p>
                        <p>实名认证</p>
                        <p>完成个人/企业实名认证</p>
                    </li>
                    <li class="dci_jt"><img src="./images/dcialive.png"/></li>
                    <li class="dci_cont">
                        <p><img src="./images/sczp.png" style="width:34px;height:34px"/></p>
                        <p>上传作品</p>
                        <p>填写信息，上传作品</p>
                    </li>
                    <li class="dci_jt"><img src="./images/dcialive.png"/></li>
                    <li class="dci_cont">
                        <p><img src="./images/xzbl.png" style="width:34px;height:34px"/></p>
                        <p>协助办理</p>
                        <p>全程协助资料提交</p>
                    </li>
                    <li class="dci_jt"><img src="./images/dcialive.png"/></li>
                    <li class="dci_cont">
                        <p><img src="./images/bqjsh.png" style="width:28px;height:32px"/></p>
                        <p>版权局审核</p>
                        <p>1-10个工作日完成审核</p>
                    </li>
                    <li class="dci_jt"><img src="./images/dcialive.png"/></li>
                    <li class="dci_cont">
                        <p><img src="./images/bfzs.png" style="width:33px;height:24px"/></p>
                        <p>颁发证书</p>
                        <p>获得作品登记证书</p>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 版权检测 -->
        <div class="jiance_box">
            <h2 class="jiance_tit">版权监测</h2>
            <p class="jiance_txt">通过全网监测技术，及时发现互联网上的侵权线索</p>
            <ul class="jiance_list">
                <li class="jiance_li jiance_li_bd">
                    <div>
                        <!-- <img src='./images/jc_img.png' class="bd_img"/> -->
                        <span class="bd_img_tu bd_img"></span>
                        <p class="list_tit">图、音、文监测</p>
                        <p class="list_txt" style="margin:17px 0 28px">支持图片、音乐、文字类型的作品监测</p>
                        <p class="list_btn" @click="goMonitor"><span>去监测</span><i></i></p>
                    </div>
                </li>
<!--                <li class="jiance_li" style="margin-left:24px">-->
<!--                    <ul class="jiance_li_list">-->
<!--                        <li>-->
<!--                            <span class="g_img g_img_gzh"></span>-->
<!--                            &lt;!&ndash; <img src='./images/jc_gzh.png' class="g_img"/> &ndash;&gt;-->
<!--                            <div>-->
<!--                                <p class="list_tit" style="margin-top:39px">公众号监测</p>-->
<!--                                <p class="list_txt" style="margin:11px 0 24px">可对微信公众号内容进行监测</p>-->
<!--                                <p class="list_btn" @click="goMonitor"><span>去监测</span><i></i></p>-->
<!--                            </div>-->
<!--                        </li>-->
<!--                        <li style="margin-top:24px">-->
<!--                            &lt;!&ndash; <img src='./images/jc_zd.png' class="g_img"/> &ndash;&gt;-->
<!--                            <span class="g_img g_img_zd"></span>-->
<!--                            <div>-->
<!--                                <p class="list_tit" style="margin-top:34px">常用站点监测</p>-->
<!--                                <p class="list_txt" style="margin:11px 0 10px">根据不同作品类型，提供对人们常用熟知的站点进行监测</p>-->
<!--                                <p class="list_btn" @click="goMonitor"><span>去监测</span><i></i></p>-->
<!--                            </div>-->
<!--                        </li>-->
<!--                    </ul>-->
<!--                </li>-->
              <li class="jiance_li jiance_li_bd" style="margin-left:24px">
                <div>
                  <!-- <img src='./images/jc_ds.png' class="bd_img_ds bd_img"/> -->
                  <span class="bd_img_dt bd_img"></span>
                  <p class="list_tit">公众号监测</p>
                  <p class="list_txt" style="margin:17px 0 28px">可对微信公众号内容进行监测</p>
                  <p class="list_btn" @click="goMonitor"><span>去监测</span><i></i></p>
                </div>
              </li>
                <li class="jiance_li jiance_li_bd" style="margin-left:24px">
                    <div>
                        <!-- <img src='./images/jc_ds.png' class="bd_img_ds bd_img"/> -->
                        <span class="bd_img_ds bd_img"></span>
                        <p class="list_tit">电商平台监测</p>
                        <p class="list_txt" style="margin:17px 0 28px">淘宝、京东、拼多多等常见电商监测</p>
                        <p class="list_btn" @click="goMonitor"><span>去监测</span><i></i></p>
                    </div>
                </li>
            </ul>
        </div>
        <!-- 侵权取证 -->
        <div class="qinquan_box">
            <h2 class="qinquan_tit">侵权取证</h2>
            <p class="qinquan_txt">提供丰富的取证工具，满足取证全场景的需要</p>
            <ul class="qinquan_list">
                <li>
                    <span class="wy_img"></span>
                    <p>网页取证</p>
                    <p>经严格的司法鉴定检验，版权家取证技术可确保网页截屏的证据真实有效、完整不被篡改</p>
                    <p @click="evidenceWeb"><span>开始取证</span><i class="left"></i></p>
                </li>
                <li>
                    <span class="gc_img"></span>
                    <p>过程录屏取证</p>
                    <p>提供安全清洁的云桌面系统，可模拟真实的用户电脑使用环境，操作过程全程录屏，适用于电脑端取证</p>
                    <p @click="gcquzheng"><span>开始取证</span><i class="left"></i></p>
                </li>
                <li style="padding: 50px 20px 0;">
                    <span class="cj_img"></span>
                    <p>场景取证</p>
                    <p>版权家研发的取证宝APP，可随时随地对侵权场景进行拍照、录像、录音取证，证据受司法认可、真实有效</p>
                    <p @click="downLoadQzb"><span>下载取证宝APP</span><i class="btm"></i></p>
                </li>
                <li>
                    <span class="iphone_img"></span>
                    <p>手机录屏取证</p>
                    <p>版权家研发的取证宝APP，可对手机应用中发现的侵权内容进行录屏取证，是维护自身权益的利器</p>
                    <p @click="downLoadQzb"><span>下载取证宝APP</span><i class="btm"></i></p>
                </li>
            </ul>
        </div>
        <!-- 法律维权 -->
        <div class="weiquan_box">
            <h2>法律维权</h2>
            <p>专业律师团队，专注解决版权法律问题</p>
            <div class="weiquan_cont">
                <ul class="weiquan_cont_left">
                    <li class="left_tit">
                        <span>在版权维权过程中可以帮您</span>
                    </li>
                    <li class="left_list">
                        <img src="./images/weiquan_list.png"/>
                        <span>专业解答版权方面的法律问题，帮助咨询者提升法律知识，解决版权确权、维权、交易等方面的疑问</span>
                    </li>
                    <li class="left_list">
                        <img src="./images/weiquan_list.png"/>
                        <span>针对维权案件的诉求，协助挖掘梳理维权过程中的细节和风险点，制定维权方案，提升胜诉率，提高获赔金额</span>
                    </li>
                    <li class="left_list">
                        <img src="./images/weiquan_list.png"/>
                        <span>对协议合同提供专业指导建议，根据需求为您起草或审核协议合同，对关键事项细致辅导，助您规避法律风险</span>
                    </li>
                    <li class="left_list">
                        <img src="./images/weiquan_list.png"/>
                        <span>可为维权事件分析赔偿数额，对侵权站点进行侵权下架，对侵权者出具律师函等专业维权工作</span>
                    </li>
                    <li class="left_btn" @click="zixunLs">
                        <span>立即咨询</span>
                        <!-- <img src="./images/leftjt.png"/> -->
                        <i></i>
                    </li>
                </ul>
                <img src="./images/weiquan_ipone.png" class="weiquan_cont_right"/>
            </div>
        </div>
        <!-- 资讯动态 -->
        <div class="zixun_box">
            <h2>资讯动态</h2>
            <p>了解版权家最新动态，关注版权行业发展</p>
            <div class="zixun_cont">
                <div class="zixun_left">
                    <div class="left_tit">
                        <span>版权新闻</span>
                        <a @click="moreZixun">更多资讯<i></i></a>
                    </div>
                    <img :src="cardLists && cardLists[0].image" class="left_img"/>
                    <div class="left_list_one" @click="oneZixun">
                        <p>{{cardLists && cardLists[0].title}}</p>
                        <p>{{cardLists && cardLists[0].description}}</p>
                        <p>{{cardLists && cardLists[0].updateDate}}</p>
                    </div>
                    <ul class="left_list_two">
                        <li style="border-right:1px dashed #E5E5E5" @click="twoZixun" class="li_one">
                            <p>{{cardLists && cardLists[1].title}}</p>
                            <p>{{cardLists && cardLists[1].description}}</p>
                            <p>{{cardLists && cardLists[1].updateDate}}</p>
                        </li>
                        <li style="padding-left:34px;box-sizing:border-box" @click="threeZixun" class="li_two">
                            <p>{{cardLists && cardLists[2].title}}</p>
                            <p>{{cardLists && cardLists[2].description}}</p>
                            <p>{{cardLists && cardLists[2].updateDate}}</p>
                        </li>
                    </ul>
                </div>
                <div class="zixun_right">
                    <p class="right_tit"><span>专家问答</span><a @click='moreWenda'>查看更多<i></i></a></p>
                    <div class="list-search">
                        <input v-model="questionVal" placeholder="请输入您想要了解的问题或关键字" class="select-input"/>
                        <img src='./images/search.png'  @click="askQuestion"/>
                    </div>
                    <ul class="right_list" v-if="messageList && messageList.length>0">
                        <li v-for="(item,index) in messageList" :key="index" @click="wendaList(item)">{{item.content}}</li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 合作伙伴 -->
        <div class="parner_box">
            <h2>合作伙伴</h2>
            <p>与优秀的企业一同成长</p>
            <div class="parner_carousel">
                <Carousel
                    v-model="value3"
                    :autoplay="setting.autoplay"
                    :autoplay-speed="setting.autoplaySpeed"
                    :dots="setting.dots"
                    :radius-dot="setting.radiusDot"
                    :trigger="setting.trigger"
                    :arrow="setting.arrow">
                    <CarouselItem>
                        <div class="demo-carousel" @mouseover="mouseOver" @mouseleave="mouseLeave">
                            <img src='./images/hezuohuoban/qkl.png'/>
                            <img src='./images/hezuohuoban/am.png'/>
                            <img src='./images/hezuohuoban/fy.png'/>
                            <img src='./images/hezuohuoban/four.png'/>
                            <img src='./images/hezuohuoban/five.png'/>
                            <img src='./images/hezuohuoban/ss.png'/>
                            <img src='./images/hezuohuoban/st.png'/>
                            <img src='./images/hezuohuoban/yk.png'/>
                            <img src='./images/hezuohuoban/ysp.png'/>
                            <img src='./images/hezuohuoban/bqbh.png'/>
                            <img src='./images/hezuohuoban/wz.png'/>
                            <img src='./images/hezuohuoban/cbd.png'/>
                            <img src='./images/hezuohuoban/the.png'/>
                            <img src='./images/hezuohuoban/caasa.png'/>
                            <img src='./images/hezuohuoban/bd.png'/>
                            <img src='./images/hezuohuoban/bdyx.png'/>
                            <img src='./images/hezuohuoban/ys.png'/>
                            <img src='./images/hezuohuoban/ysyx.png'/>
                        </div>
                    </CarouselItem>
                    <CarouselItem>
                        <div class="demo-carousel" @mouseover="mouseOver" @mouseleave="mouseLeave">
                            <img src='./images/hezuohuoban/albb.png'/>
                            <img src='./images/hezuohuoban/bjws.png'/>
                            <img src='./images/hezuohuoban/myjf.png'/>
                            <img src='./images/hezuohuoban/jd.png'/>
                            <img src='./images/hezuohuoban/zglt.png'/>
                            <img src='./images/hezuohuoban/zgyd.png'/>
                            <img src='./images/hezuohuoban/zgdx.png'/>
                            <img src='./images/hezuohuoban/hw.png'/>
                            <img src='./images/hezuohuoban/hna.png'/>
                            <img src='./images/hezuohuoban/ssjt.png'/>
                            <img src='./images/hezuohuoban/mt.png'/>
                            <img src='./images/hezuohuoban/bw.png'/>
                            <img src='./images/hezuohuoban/xm.png'/>
                            <img src='./images/hezuohuoban/xlwb.png'/>
                            <img src='./images/hezuohuoban/sso.png'/>
                            <img src='./images/hezuohuoban/res.png'/>
                            <img src='./images/hezuohuoban/fis.png'/>
                            <img src='./images/hezuohuoban/zeepson.png'/>
                        </div>
                    </CarouselItem>
                    <CarouselItem>
                        <div class="demo-carousel" @mouseover="mouseOver" @mouseleave="mouseLeave">
                            <img src='./images/hezuohuoban/huo.png'/>
                            <img src='./images/hezuohuoban/sebe.png'/>
                            <img src='./images/hezuohuoban/tiany.png'/>
                            <img src='./images/hezuohuoban/ch.png'/>
                            <img src='./images/hezuohuoban/no.png'/>
                            <img src='./images/hezuohuoban/aoss.png'/>
                            <img src='./images/hezuohuoban/fz.png'/>
                            <img src='./images/hezuohuoban/gy.png'/>
                            <img src='./images/hezuohuoban/ycb.png'/>
                            <img src='./images/hezuohuoban/yjdz.png'/>
                            <img src='./images/hezuohuoban/sql.png'/>
                            <img src='./images/hezuohuoban/sami.png'/>
                            <img src='./images/hezuohuoban/fisb.png'/>
                        </div>
                    </CarouselItem>
                </Carousel>
            </div>
        </div>
        <!-- <footerNew></footerNew> -->
        <!--取证宝下载弹框-->
        <Modal v-model="downLoad" width="1200" :mask-closable="false" footer-hide class="model_qzb_box">
           <div class="model_box">
               <div class="model_box_left"><img src="./images/hezuohuoban/qzb_sj.png"/></div>
               <div class="model_box_right">
                   <div class="right_top">
                       <img src="./images/hezuohuoban/qzb_logo.png"/>
                       <ul>
                           <li>取证宝APP</li>
                           <li>取证宝APP支持拍照、录像、录音、手机录屏等取证功能，证据受司法认可，真实有效</li>
                       </ul>
                   </div>
                   <div class="right_btm">
                       <div class="right_btm_left"><img src="./images/hezuohuoban/qzb_ewm.png"/></div>
                       <ul class="right_btm_right">
                           <li class="btm_load" style="margin:15px 0 24px;">
                               <img src='./images/hezuohuoban/qzb_pg.png'/>
                               <span style="cursor: pointer;" @click="iosLoad">iPhone下载</span>
                           </li>
                           <li class="btm_load">
                               <img src='./images/hezuohuoban/qzb_anz.png'/>
                               <span style="cursor: pointer;" @click="androidLoad">Android下载</span>
                           </li>
                           <li class="btm_txt">*打开手机扫一扫左侧二维码即可下载APP</li>
                       </ul>
                   </div>
               </div>
           </div>
        </Modal>
    </div>
</template>

<script>
import headerNew from '@/views/main-components/opcatHeader';
// import footerNew from '@/views/main-components/footerNew';
import Cookies from "js-cookie";
import {_getDictList} from '@/api/staticPage'
 import { _getColumn,_getValidByPage,_updatePageviews,_getValidPage } from "@/api/consultation";
    export default {
        metaInfo: {
            title: '版权登记|版权保护-版权服务专家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权登记,版权保护,版权登记查询,版权保护中心,版权保护服务,版权登记服务,版权家'
            },{
                name: 'Description',
                content: '版权家是专业提供版权登记查询，版权保护申请；我们作为版权保护服务专家，为版权人提供极致的版权登记咨询、版权交易、版权监测、版权维权等服务体验。'
            }]
        },
        name:'firstPage',
        components:{
            headerNew,
            // footerNew
        },
        data(){
            return {
                vipFlag: 0, //VIP类型 0未开通 1vip会员  2体验会员
                downLoad:false,
                value3:0,
                setting: {
                    autoplay: true,
                    autoplaySpeed: 2000,
                    dots: 'outside',
                    radiusDot: false,
                    trigger: 'click',
                    arrow: 'never'
                },
                questionVal:"",
                tabsList:[],
                pageNumber:1,
                pageSize:3,
                sort:"",
                order:"desc",
                categoryId:"",
                title:"",
                cardLists:[],
                messageList:[],
                questionVal:"",
                showSpan:true,
                content:"",
                showDialog:!1,
                reContent:"",
                pathname:'',
                maintitle:'',
                defalutImg:require('@/assets/news1.png'),
            }
        },

        methods:{
            iosLoad(){
                window.open("https://apps.apple.com/cn/app/%E5%8F%96%E8%AF%81%E5%AE%9D/id1184801162?mt=8",'_blank')
            },
            androidLoad(){
                let data = {type: 'qzb_android_link'};
                _getDictList(data).then(res => {
                    if (res.code == 200) {
                        window.open(res.result[0].value)
                    }
                })
            },
            
            isOpenVip(){
                let userInfo = Cookies.get("userInfo");
                if (userInfo && userInfo != '') {
                    userInfo = JSON.parse(userInfo);
                    let vipFlag = userInfo.vipFlag;
                    this.vipFlag = vipFlag
                } else {
                    this.vipFlag = 0
                }
            },
            mouseOver(){
                this.setting.autoplay = false;
            },
            mouseLeave(){
                this.setting.autoplay = true;
            },
            wendaList(data){
                let tempUrl = '/online-answers/'+data.id
                window.open(tempUrl+".html",'_blank')
            },
            oneZixun(){
                let tempUrl = '/consultation-info/'+this.cardLists[0].id
                window.open(tempUrl+".html",'_blank')
            },
            twoZixun(){
                let tempUrl = '/consultation-info/'+this.cardLists[1].id
                window.open(tempUrl+".html",'_blank')
            },
            threeZixun(){
                let tempUrl = '/consultation-info/'+this.cardLists[2].id
                window.open(tempUrl+".html",'_blank')
            },
            askQuestion(){
                this.content=this.questionVal;
                this.getValidPage()
            },
            
            
            lookCzDetail(){
                this.$router.push({path: '/cunzheng.html'})
            },
            lookDciDetail(){
                this.$router.push({path: '/cunzheng.html'})
            },
            
            
           
            
            moreZixun(){
                this.$router.push({path: '/consultation-list'})
            },
            moreWenda(){
                this.$router.push({path: '/wenda.html'})
            },
            
            //更新浏览量
            updateNum(value){
                _updatePageviews({id:value}).then(res=>{
                    if(res.code==200){
                     console.log("浏览量+1")
                    }
                })
                let tempUrl = '/consultation-info/'+value
                window.open(tempUrl+".html",'_blank')
                // this.$router.push({path: '/consultation-info', query: {id:value }});
            },
            //获取顶部菜单   
            getColumn(pathname) {
                _getColumn().then(res => {
                    if(res.code==200){
                    const topMenu = res.result;       
                    topMenu.length>0&&topMenu.map((item)=>{
                        if(item.id==2){
                            this.tabsList = item.childs;            
                            this.categoryId=item.childs[0].id;
                        }
                    });
                    this.getValidByPage();
                    }
                });
                this.pathname = pathname
            },
            //分页查询有效文章
            getValidByPage(){
                const data ={
                    pageNumber:this.pageNumber,
                    pageSize:this.pageSize,
                    sort:"create_date",
                    order:"desc",
                    categoryId:this.categoryId,
                    title:""
                }
                _getValidByPage(data).then(res => {
                    if(res.code==200){
                    this.cardLists= res.result.records;
                    console.log(this.cardLists)
                    this.total = Number(res.result.total);
                    this.pages = Number(res.result.pages);
                    }
                });
            },
            //分页查询有效留言
            getValidPage(pathname){
                const value ={
                    pageNumber:1,
                    pageSize:6,
                    sort:"create_date",
                    order:"desc",
                    registerId:"",
                    content:this.content,
                    phone:""
                }
                _getValidPage(value).then(res => {
                    if(res.code==200){
                        this.messageList = res.result.records
                    }
                });
                this.pathname = pathname
            },
        },
        mounted(){
            this.isOpenVip();
            this.getColumn();
            this.getValidPage();
        },
        created(){
            

        },
        watch: {
            $route(to, from) {
                let pathname = to.path;
                this.getColumn(pathname);
                this.getValidPage(pathname);
            }
        },
        beforeDestroy(){
        },

    }
</script>

<style scoped lang="less">
// @media screen and (max-width:1920px) {
    .banner_top_big{
    height: 910px;
    position: relative;
}
.dabanner{
        height: 696px;
    }
.top_box{
    position: absolute;
    top:0px;
    width: 100%;
    /deep/ .el-carousel{
        height:696px;
    }
    /deep/ .el-carousel__container{
        height: 696px;
    }
    /deep/ .first_width{
        position: relative;
    }
    
    /deep/ .el-carousel__indicators{
        width: 1200px;
        height: 10px;
        top: 0;
        text-align: right;
        margin: auto;
        bottom: 0;
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        top:370px;
    }
}
    //banner
    .banner_box{
        .first_banner{
            .first_width{
                position: relative;
                .first_left{
                    position: absolute;
                    width: 1200px;
                    left: 50%;
                    margin-left: -600px;
                    display: flex;
                    &>div{
                        flex: 1;
                    }
                    &>img{
                        display: block;
                        width: 466px;
                        height: 435px;
                        margin-top: 117px;
                    }
                    .banner_po{
                        font-size: 54px;
                        font-weight: 800;
                        color: #FFFFFF;
                        line-height: 80px;
                        margin-top:182px;
                        font-family:SourceHanSansCN;
                    }
                    .banner_pt{
                        font-size: 22px;
                        font-weight: 500;
                        font-family:SourceHanSansCN;
                        color: #FFFFFF;
                        line-height: 23px;
                        margin: 48px 0 22px;
                    }
                    .banner_pr{
                        font-size: 16px;
                        color: #FFFFFF;
                        line-height: 22px;
                        margin-bottom: 58px;
                    }
                    .banner_btn{
                        width: 154px;
                        height: 40px;
                        background: #FBDA5D;
                        border-radius: 20px;
                        font-size: 14px;
                        font-weight: bold;
                        color: #333333;
                        line-height:40px;
                        text-align: center;
                        letter-spacing: 1px;
                        display: block;
                        font-family:SourceHanSansCN;
                        &:hover{
                            box-shadow: 0px 4px 8px 0px rgba(255, 216, 0, 0.6);
                        }
                    }
                }
            }
        }
    }
    //2
    .banner_btm_box{
        width: 1201px;
        height: 334px;
        background: #FFFFFF;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
        position: absolute;
        bottom: 10px;
        left: 50%;
        margin-left: -600px;
        z-index: 2;
        border-radius:20px;
        display: flex;
        padding: 35px 0;
        box-sizing: border-box;
        .banner_btm_flex{
            flex: 1;
            border-right:1px solid #EFEFEF;
            padding:0 0px 0 46px;
            box-sizing: border-box;
            .banner_btm_flex_tit{
                font-size: 24px;
                font-weight: bold;
                font-family:SourceHanSansCN;
                color: #000000;
                line-height: 36px;
                vertical-align: middle;
                text-align: center;
                img{
                    width: 32px;
                    height: 32px;
                    display: inline-block;
                    margin-right: 3px;
                    vertical-align: middle;
                }
                span{
                    vertical-align: middle;
                }
            }
            .list_tit{
                font-size: 16px;
                font-weight: 700;
                font-family:SourceHanSansCN;
                color: #333333;
                line-height: 24px;
                margin: 28px 0 13px;
            }
            .list_txt{
                font-size: 12px;
                color: #444444;
                line-height: 24px;
                span{
                    display: inline-block;
                    margin-right: 14px;
                    cursor: pointer;
                    &:hover{
                        color: #F9C300;
                    }
                }
            }
        }
        .banner_btm_flex:last-child{
            border: none;
        }
        ul{
            li{
                list-style: none;
            }
        }
    }


    //荣誉资质
    .ryzz_box_big{
        width: 1217px;
        height: 110px;
        margin: auto;
    }
    .ryzz_box{
        background: url('./images/ryzz_bg.png') 100% 100% no-repeat;
        display: flex;
        padding:23px 0;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        background-size: cover;
        .ryzz_box_left{
            width: 162px;
            border-right:1px solid rgba(214,172,109,0.18);
            text-align: center;
            img{
                width: 47px;
                height: 40px;
                display: block;
                margin-bottom: 4px;
                margin: auto;
            }
            span{
                font-size: 16px;
                color:#DBAF6D;
                line-height: 24px;
                // color: angular-gradient(90deg, #EAD2AF 0%, #DBAF6D 100%);
            }
        }
        .ryzz_box_right{
            -webkit-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            font-size: 14px;
            color: #B6915A;
            line-height: 20px;
            padding-left: 54px;
            box-sizing: border-box;
            img{
                width: 15px;
                height: 14px;
                display: inline-block;
                // margin-right: 4px;
                position: absolute;
                left: 0;
                top: 3px;
            }
            li{
                // width: 33.33%;
                float: left;
                margin-top: 14px;
                position: relative;
                padding-left: 20px;
            }
        }
    }
    //版权存证
    .cz_box{
        display: flex;
        width: 1200px;
        margin: 0px auto 130px;
        .cz_zhengshu{
            width: 540px;
            height: 390px;
            display: block;
            margin: 103px 100px 0 21px;
        }
        .dci_zhengshu{
             width:540px;
            height:390px;
            display: block;
                margin-top: 97px;
            // margin: 0 115px 0 47px;
        }
        .cz_right{
            flex:1;
            margin-top: 128px;
            .cz_right_tit{
                font-size: 32px;
                font-weight: bold;
                font-family:SourceHanSansCN;
                color: #333333;
                line-height: 47px;
                margin:0px 0 16px; 
            }
            .cz_right_t{
                font-size: 16px;
                font-weight: bold;
                font-family:SourceHanSansCN;
                color: #333333;
                line-height: 27px;
            }
            .cz_right_list{
                display: flex;
                margin-top:40px;
                margin-bottom:56px;
                li{
                    flex:1;
                    // width: 130px;
                    
                    img{
                        width:46px;
                        height:46px;
                        display: block;
                        margin: 0 38px;
                    }
                    span:nth-of-type(1){
                        font-size: 16px;
                        font-weight: 500;
                        font-family:SourceHanSansCN;
                        color: #333333;
                        line-height: 27px;
                        display: block;
                        margin: 5px 0 3px;
                        width: 130px;
                        text-align: center;
                    }
                    span:nth-of-type(2){
                        font-size: 12px;
                        color: #555555;
                        line-height: 18px;
                        display: block;
                        width: 130px;
                        text-align: center;
                    }
                }
            }
            .dci_right_btn{
                .yellow{
                    font-size: 14px;
                    color: #F5F5F5;
                    line-height: 40px;
                    width: 154px;
                    height: 40px;
                    border-radius: 20px;
                    display: inline-block;
                    cursor: pointer;
                    position: relative;
                    padding-left: 38px;
                    background: #FBDA5D;
                    border: 1px solid #FBDA5D;
                    color: #333333;
                    i{
                        margin-left: 6px;
                        width: 14px;
                        height: 14px;
                        display:inline-block;
                        position: absolute;
                        top: 13px;
                        background: url("./images/goHover.png") no-repeat;
                        background-size: 100% 100%;
                    }
                    &:hover{
                        box-shadow: 0px 4px 8px 0px rgba(255, 216, 0, 0.6);
                    }
                }
                // a{
                //     font-size: 14px;
                //     color: #F5F5F5;
                //     line-height: 40px;
                //     width: 154px;
                //     height: 40px;
                //     border-radius: 20px;
                //     border: 1px solid #E5E5E5;
                //     display: inline-block;
                //     // text-align: center;
                //     // display: flex;
                //     // justify-content: center;
                //     // align-items: center;
                //     cursor: pointer;
                //     position: relative;
                //     padding-left: 38px;
                //     i{
                //         margin-left: 6px;
                //         width: 14px;
                //         height: 14px;
                //         display:inline-block;
                //         position: absolute;
                //         top: 13px;
                //         background: url("./images/dci_go.png") no-repeat;
                //         background-size: 100% 100%;
                //     }
                //     &:hover{
                //         background: #FBDA5D;
                //         border: 1px solid #FBDA5D;
                //         color: #333333;
                //         i{
                //             margin-left: 6px;
                //             width: 14px;
                //             height: 14px;
                //             display:inline-block;
                //             position: absolute;
                //             top: 13px;
                //             background: url("./images/goHover.png") no-repeat;
                //             background-size: 100% 100%;
                //         }
                //     }
                // }
            }
            .cz_right_btn{
                .yellow{
                    cursor: pointer;
                    font-size: 14px;
                    line-height: 40px;
                    width: 154px;
                    height: 40px;
                    border-radius: 20px;
                    border: 1px solid #E5E5E5;
                    display: inline-block;
                    position: relative;
                    padding-left: 38px;
                    background: #FBDA5D;
                    border: 1px solid #FBDA5D;
                    color: #333333;
                    // text-align: center;
                    span{
                        margin-left: 6px;
                        width: 14px;
                        height: 14px;
                        background: url("./images/goHover.png") no-repeat;
                        background-size: 100% 100%;
                        display: inline-block;
                        position: absolute;
                        top: 13px;
                    }
                    &:hover{
                        box-shadow: 0px 4px 8px 0px rgba(255, 216, 0, 0.6);
                    }
                }
                .normal{
                    cursor: pointer;
                    font-size: 14px;
                    color: #666666;
                    line-height: 40px;
                    width: 154px;
                    height: 40px;
                    border-radius: 20px;
                    border: 1px solid #E5E5E5;
                    display: inline-block;
                    position: relative;
                    padding-left: 38px;
                    // text-align: center;
                    span{
                        margin-left: 6px;
                        width: 14px;
                        height: 14px;
                        background: url("./images/go.png") no-repeat;
                        background-size: 100% 100%;
                        display: inline-block;
                        position: absolute;
                        top: 13px;
                    }
                    &:hover{
                        background: #FBDA5D;
                        border: 1px solid #FBDA5D;
                        color: #333333;
                        box-shadow: 0px 4px 8px 0px rgba(255, 216, 0, 0.6);
                        span{
                            margin-left: 6px;
                            width: 14px;
                            height: 14px;
                            background: url("./images/goHover.png") no-repeat;
                            background-size: 100% 100%;
                            display: inline-block;
                            position: absolute;
                            top: 13px;
                        }
                    }
                }
            }
        }
    }
    //版权登记
    .dci_all{
        position: relative;
        height:863px;
        .dci_bigbox{
            background: url("./images/dci_bg.png") no-repeat;
            width: 100%;
            height: 646px;
            background-size: cover;
            .cz_box{
                .cz_right{
                    margin-top: 131px;
                }
            }
            // padding-top:100px;
            // box-sizing: border-box;
        }
        .fwlc_box{
            position: absolute;
            width: 1200px;
            height: 205px;
            background: #FFFFFF;
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
            border-radius: 20px;
            top: 579px;
            left: 50%;
            margin-left: -600px;
            h2{
                font-size: 24px;
                font-weight: bold;
                color: #333333;
                line-height: 36px;
                margin: 19px 0 10px;
                text-align: center;
                font-family:SourceHanSansCN;
            }
            ul{
                display: flex;
                .dci_cont{
                    flex: 1;
                    text-align:center;
                }
                .dci_jt{
                    width: 26px;
                    margin-top: 45px;
                }
                li{
                    &>img{
                        width: 26px;
                        height: 14px;
                    }
                    p:nth-of-type(1){
                        width: 54px;
                        height: 54px;
                        border-radius: 50%;
                        background: #FFFFFF;
                        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        margin:auto;
                    }
                    p:nth-of-type(2){
                        font-size: 16px;
                        font-weight: bold;
                        font-family:SourceHanSansCN;
                        color: #333333;
                        line-height: 24px;
                        margin:6px 0 2px;
                    }
                    p:nth-of-type(3){
                        font-size: 11px;
                        color: #999999;
                        line-height: 17px;
                    }
                }
                
            }
        }
    }
    //版权检测
    .jiance_box{
        width: 1200px;
        margin: auto;
        padding-bottom: 80px;
        box-sizing: border-box;
        .jiance_tit{
            font-size: 32px;
            font-weight: bold;
            font-family:SourceHanSansCN;
            color: #333333;
            line-height: 47px;
            text-align: center;
        }
        .jiance_txt{
            font-size:14px;
            font-weight: 400;
            font-family:SourceHanSansCN;
            color: #999999;
            line-height:20px;
            text-align: center;
            margin: 8px 0 40px;
        }
        .list_tit{
            font-size: 18px;
            font-weight: bold;
            font-family:SourceHanSansCN;
            color: #333333;
            line-height: 27px;
        }
        .list_txt{
            font-size: 14px;
            color: #666666;
            line-height: 20px;
        }
        .list_btn{
            vertical-align: middle;
            font-size: 14px;
            color: #999999;
            cursor: pointer;
            span{
                vertical-align: middle;
            }
            i{
                vertical-align: middle;
                width: 14px;
                height: 10px;
                display: inline-block;
                margin-left: 6px;
                background: url("./images/jc_jt.png");
                background-size: 100% 100%;
            }
            &:hover{
                color: #333333;
                i{
                    vertical-align: middle;
                    width: 14px;
                    height: 10px;
                    display: inline-block;
                    margin-left: 6px;
                    background: url("./images/jc_jt_hover.png");
                    background-size: 100% 100%;
                }
            }
        }
        .jiance_list{
            display: flex;
            .jiance_li{
                flex:1;
                .jiance_li_list{
                    li{
                        width: 384px;
                        height: 172px;
                        background: #FFFFFF;
                        border-radius: 10px;
                        border: 1px solid #F5F5F5;
                        display: flex;
                        div{
                            flex: 1;
                        }
                        .g_img{
                            width: 64px;
                            height: 64px;
                            margin: 40px 36px 0;
                        }
                        .g_img_gzh{
                            background: url("./images/jc_gzh_no.png") no-repeat;
                            background-size: 100% 100%;
                        }
                        .g_img_zd{
                            background: url("./images/jc_zd_no.png") no-repeat;
                            background-size: 100% 100%;
                        }
                        &:hover{
                            box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15);
                            .g_img_gzh{
                                background: url("./images/jc_gzh.png") no-repeat;
                                background-size: 100% 100%;
                            }
                            .g_img_zd{
                                background: url("./images/jc_zd.png") no-repeat;
                                background-size: 100% 100%;
                            }
                            // .list_btn{
                            //     color: #333333;
                            //     i{
                            //         vertical-align: middle;
                            //         width: 14px;
                            //         height: 10px;
                            //         display: inline-block;
                            //         margin-left: 6px;
                            //         background: url("./images/jc_jt_hover.png");
                            //         background-size: 100% 100%;
                            //     }
                            // }
                        }
                    }
                }
            }
            .jiance_li_bd{
                text-align: center;
                width: 384px;
                height: 368px;
                background: #FFFFFF;
                border-radius: 10px;
                border: 1px solid #F5F5F5;
                .bd_img_tu{
                    background: url("./images/jc_img_no.png") no-repeat;
                    background-size: 100% 100%;
                }
                .bd_img_ds{
                    background: url("./images/jc_zd_no.png") no-repeat;
                    background-size: 100% 100%;
                }.bd_img_dt{
                   background: url("./images/jc_gzh_no.png") no-repeat;
                   background-size: 100% 100%;
                 }
                .bd_img{
                    width: 100px;
                    height: 100px;
                    display: block;
                    margin: 60px auto 50px;
                }
                &:hover{
                    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15);
                    .bd_img_tu{
                        background: url("./images/jc_img.png") no-repeat;
                        background-size: 100% 100%;
                    }
                    .bd_img_ds{
                        background: url("./images/jc_zd.png") no-repeat;
                        background-size: 100% 100%;
                    }.bd_img_dt{
                       background: url("./images/jc_gzh.png") no-repeat;
                       background-size: 100% 100%;
                     }
                    // .list_btn{
                    //     color: #333333;
                    //     i{
                    //         vertical-align: middle;
                    //         width: 14px;
                    //         height: 10px;
                    //         display: inline-block;
                    //         margin-left: 6px;
                    //         background: url("./images/jc_jt_hover.png");
                    //         background-size: 100% 100%;
                    //     }
                    // }
                }
            }
        }
    }
    //侵权取证
    .qinquan_box{
        background: url("./images/qu_bg.png") no-repeat;
        width: 100%;
        height: 730px;
        background-size: 100% 100%;
        .qinquan_tit{
            font-size: 32px;
            font-weight: bold;
            font-family:SourceHanSansCN;
            color: #333333;
            line-height: 47px;
            padding-top: 90px;
            box-sizing: border-box;
            text-align: center;
        }
        .qinquan_txt{
            font-size: 14px;
            color: #999999;
            line-height: 20px;
            text-align: center;
            margin:8px 0 40px;
        }
        .qinquan_list{
            width: 1200px;
            margin: auto;
            display: flex;
            li{
                flex: 1;
                margin-right: 24px;
                width: 282px;
                height: 428px;
                background: #FFFFFF;
                border-radius: 10px;
                padding: 50px 28px 0;
                &:hover{
                    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15);
                    p:nth-of-type(3){
                        background: #FBDA5D;
                        border-color: #FBDA5D;
                        color: #333333;
                        .left{
                            background: url("./images/goHover.png") no-repeat;
                            background-size: 100% 100%;
                        }
                        .btm{
                            background: url("./images/xiaHover.png") no-repeat;
                            background-size: 100% 100%;
                        }
                    }
                    .wy_img{
                        background: url("./images/wangye_se.png") no-repeat;
                        background-size: 100% 100%;
                    }
                    .gc_img{
                        background: url("./images/guocheng_se.png") no-repeat;
                        background-size: 100% 100%;
                    }
                    .cj_img{
                        background: url("./images/changjing_se.png") no-repeat;
                        background-size: 100% 100%;
                    }
                    .iphone_img{
                        background: url("./images/shouji_se.png") no-repeat;
                        background-size: 100% 100%;
                    }
                }
                &>span{
                    width: 100px;
                    height: 78px;
                    display:block;
                    margin: auto;
                }
                .wy_img{
                    background: url("./images/wangye_no.png") no-repeat;
                    background-size: 100% 100%;
                }
                .gc_img{
                    background: url("./images/guocheng_no.png") no-repeat;
                    background-size: 100% 100%;
                }
                .cj_img{
                    background: url("./images/changjing_no.png") no-repeat;
                    background-size: 100% 100%;
                }
                .iphone_img{
                    background: url("./images/shouji_no.png") no-repeat;
                    background-size: 100% 100%;
                }
                p:nth-of-type(1){
                    font-size: 18px;
                    font-weight: bold;
                    font-family:SourceHanSansCN;
                    color: #333333;
                    line-height: 27px;
                    text-align: center;
                    margin: 40px 0 23px;
                }
                p:nth-of-type(2){
                    font-size: 14px;
                    color: #666666;
                    line-height: 28px;
                    text-align: center;
                }
                p:nth-of-type(3){
                    font-size: 14px;
                    color: #666666;
                    width: 170px;
                    height: 40px;
                    border-radius: 20px;
                    border: 1px solid #E5E5E5;
                    line-height: 40px;
                    margin: auto;
                    margin-top: 38px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    i{
                        width: 14px;
                        height: 14px;
                        margin-left: 9px;
                    }
                    .left{
                        background: url("./images/leftjt.png") no-repeat;
                        background-size: 100% 100%;
                    }
                    .btm{
                        background: url("./images/xiajt.png") no-repeat;
                        background-size: 100% 100%;
                    }
                }
            }
        }
    }
    //法律维权
    .weiquan_box{
        height: 764px;
        width: 100%;
        &>h2{
            font-size: 32px;
            font-weight: bold;
            color: #333333;
            line-height: 47px;
            text-align: center;
            padding: 87px 0 8px;
            box-sizing: border-box;
            font-family:SourceHanSansCN;
        }
        &>p{
            font-size: 14px;
            color: #999999;
            line-height: 20px;
            text-align: center;
        }
        .weiquan_cont{
            width: 1200px;
            margin: auto;
            position: relative;
            .weiquan_cont_left{
                position: absolute;
                left: 0;
                width: 519px;
                height: 418px;
                background: #FFFFFF;
                box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);
                border-radius: 10px;
                z-index: 11;
                top: 65px;
                .left_tit{
                    font-size: 18px;
                    font-weight: bold;
                    color: #333333;
                    line-height: 27px;
                    text-align: center;
                    padding: 46px 0 29px;
                    box-sizing: border-box;
                    font-family:SourceHanSansCN;
                }
                .left_list{
                    display: flex;
                    padding:0 47px;
                    box-sizing: border-box;
                    margin-bottom: 16px;
                    img{
                        width: 21px;
                        height: 16px;
                        margin-right: 5px;
                    }
                    span{
                        flex:1;
                        font-size: 14px;
                        color: #666666;
                        line-height: 20px;
                    }
                }
                .left_btn{
                    width: 226px;
                    height: 40px;
                    border-radius: 20px;
                    border: 1px solid #E5E5E5;
                    font-size: 14px;
                    color: #999999;
                    line-height:40px;
                    display: flex;
                    justify-content:center;
                    align-items: center;
                    margin:17px auto 0;
                    cursor: pointer;
                    &:hover{
                        background:#FBDA5D;
                        border-color: #FBDA5D;
                        color: #333333;
                        i{
                            width: 14px;
                            height: 14px;
                            margin-left: 8px;
                            background: url("./images/goHover.png") no-repeat;
                            background-size: 100% 100%;
                        }
                    }
                    i{
                        width: 14px;
                        height: 14px;
                        margin-left: 8px;
                        background: url("./images/leftjt.png") no-repeat;
                        background-size: 100% 100%;
                    }
                }
            }
            .weiquan_cont_right{
                width: 774px;
                height: 466px;
                position: absolute;
                right: 0;
                top:41px;
            }
        }
    }
    //资讯动态
    .zixun_box{
        width: 100%;
        height: 806px;
        background: #ABABAB;
        background: url('./images/zixun_bg.png') no-repeat;
        background-size: 100% 100%;
        &>h2{
            font-size: 32px;
            font-weight: bold;
            color: #333333;
            line-height: 47px;
            padding:87px 0 8px;
            box-sizing: border-box;
            text-align: center;
            font-family:SourceHanSansCN;
        }
        &>p{
            font-size: 14px;
            color: #999999;
            line-height: 20px;
            text-align: center;
        }
        .zixun_cont{
            width: 1200px;
            margin:41px auto 0;
            display: flex;
            .zixun_left{
                padding: 0 25px;
                box-sizing: border-box;
                width: 790px;
                height: 508px;
                background: #FFFFFF;
                box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);
                border-radius: 10px;
                margin-right: 24px;
                .left_img{
                    width: 740px;
                    height: 194px;
                    display: block;
                }
                .left_tit{
                    height: 73px;
                    span{
                        font-size: 18px;
                        font-weight: 600;
                        color: #333333;
                        line-height: 25px;
                        font-family:SourceHanSansCN;
                        margin-top: 28px;
                        display: inline-block;
                    }
                    a{
                        font-size: 14px;
                        color: #999999;
                        // line-height:14px;
                        // display: flex;
                        // justify-content: center;
                        // align-items: center;
                        position: relative;
                        float: right;
                        margin-top:28px;
                        padding-right: 25px;
                        // display: inline-block;
                        i{
                            margin-left: 8px;
                            width: 14px;
                            height: 14px;
                            display: inline-block;
                            background: url("./images/zixun_no.png") no-repeat;
                            background-size: 100% 100%;
                            position: absolute;top:2.2px;
                        }
                        &:hover{
                            color: #333333;
                            i{
                                margin-left: 8px;
                                width: 14px;
                                height: 14px;
                                display: inline-block;
                                background: url("./images/zixun_se.png") no-repeat;
                                background-size: 100% 100%;
                            }
                        }
                    }
                }
                .left_list_one{
                    border-bottom:1px dashed #E5E5E5;
                    padding-bottom: 20px;
                    box-sizing: border-box;
                    padding-top: 19px;
                    cursor: pointer;
                    p{
                        width: 740px;
                        overflow: hidden;/*超出部分隐藏*/
                        white-space: nowrap;/*不换行*/
                        text-overflow:ellipsis;/*超出部分文字以...显示*/
                        font-family:SourceHanSansCN;
                    }
                    &:hover{
                        p:nth-of-type(1){
                            font-family:SourceHanSansCN;
                            font-weight: 600;
                            color: #F9C300;
                        }
                    }
                }
                .left_list_one,.left_list_two{
                    p:nth-of-type(1){
                        font-size: 16px;
                        font-weight: 600;
                        font-family:SourceHanSansCN;
                        color: #333333;
                        line-height: 22px;
                        padding:0px 0 14px;
                        box-sizing: border-box;
                    }
                    p:nth-of-type(2){
                        font-size: 14px;
                        color: #666666;
                        line-height: 20px;
                    }
                    p:nth-of-type(3){
                        font-size: 14px;
                        color: #999999;
                        line-height: 20px;
                        margin-top: 6px;
                    }
                }
                .left_list_two{
                    display: flex;
                    box-sizing: border-box;
                    padding-top: 19px;
                    p{
                        width: 335px;
                        overflow: hidden;/*超出部分隐藏*/
                        white-space: nowrap;/*不换行*/
                        text-overflow:ellipsis;/*超出部分文字以...显示*/
                         font-family:SourceHanSansCN;
                    }
                    li{
                        flex: 1;
                        cursor: pointer;
                    }
                    .li_one{
                        &:hover{
                            p:nth-of-type(1){
                                font-family:SourceHanSansCN;
                                font-weight: 600;
                                color: #F9C300;
                            }

                        }
                    }
                    .li_two{
                        &:hover{
                            p:nth-of-type(1){
                                font-family:SourceHanSansCN;
                                font-weight: 600;
                                color: #F9C300;
                            }

                        }
                    }
                }
            }
            .zixun_right{
                width: 384px;
                height: 508px;
                background: #FFFFFF;
                box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);
                border-radius: 10px;
                padding: 0 24px;
                box-sizing: border-box;
                .right_tit{
                    height: 73px;
                    span{
                        font-size: 18px;
                        font-weight: 600;
                        color: #333333;
                        line-height: 25px;
                        margin-top: 28px;
                        font-family:SourceHanSansCN;
                        display: inline-block;
                    }
                    a{
                        font-size: 14px;
                        color: #999999;
                        // line-height:14px;
                        // display: flex;
                        // justify-content: center;
                        // align-items: center;
                        float: right;
                        margin-top:28px;
                        // display: inline-block;
                        position: relative;
                        padding-right: 25px;
                        i{
                            margin-left: 8px;
                            width: 14px;
                            height: 14px;
                            display: inline-block;
                            background: url("./images/zixun_no.png") no-repeat;
                            background-size: 100% 100%;
                            position: absolute;
                            top: 2.3px;
                        }
                        &:hover{
                            color: #333333;
                            i{
                                margin-left: 8px;
                                width: 14px;
                                height: 14px;
                                display: inline-block;
                                background: url("./images/zixun_se.png") no-repeat;
                                background-size: 100% 100%;
                            }
                        }
                    }
                }
                .list-search{
                    width: 336px;
                    height: 40px;
                    background: #F5F5F5;
                    border-radius: 8px;
                    position: relative;
                    margin-bottom:10px;
                    .select-input{
                        width: 100%;
                        padding-right: 60px;
                        padding-left:12px;
                        box-sizing: border-box;
                        border: none;
                        outline: none;
                        background: #F5F5F5;
                        line-height: 40px;
                        border-radius: 8px;
                    }
                    img{
                        position: absolute;
                        right: 24px;
                        top: 13px;
                        width: 16px;
                        height: 14px;
                        display: inline-block;
                    }
                }
                .right_list{
                    font-size: 14px;
                    color: #333333;
                    line-height: 20px;
                    li{
                        padding: 15px 0 17px;
                        box-sizing: border-box;
                        border-bottom: 1px dashed #E5E5E5;
                        width: 335px;
                        overflow: hidden;/*超出部分隐藏*/
                        white-space: nowrap;/*不换行*/
                        text-overflow:ellipsis;/*超出部分文字以...显示*/
                        cursor: pointer;
                        &:last-child{
                            border: none;
                        }
                        &:hover{
                            color: #F9C300;
                        }
                    }
                }
            }
        }
    }
    //合作伙伴
    .parner_box{
        width: 100%;
        height:587px;
        background: #fff;
        &>h2{
            font-size: 32px;
            font-weight: bold;
            color: #333333;
            line-height: 47px;
            padding:87px 0 8px;
            box-sizing: border-box;
            text-align: center;
            font-family:SourceHanSansCN;
        }
        &>p{
            font-size: 14px;
            color: #999999;
            line-height: 20px;
            text-align: center;
        }
        .parner_carousel{
            width: 1200px;
            margin:40px auto 0;
            .demo-carousel{
                img{
                    width: 180px;
                    height:80px;
                    display:inline-block;
                    margin:0 10px;
                }
            }
            /deep/ .ivu-carousel-dots{
                height: 4px;
                li{
                    padding: 0;
                    button{
                        width: 30px;
                        height: 4px;
                        background: #999999;
                        border-radius: 3px;
                        &:hover{
                            background: #FFD800 !important;
                        }
                    }
                    &:hover{
                        color: #FFD800 !important;
                    }
                }
                
            }
            /deep/ .ivu-carousel-item{
                img{
                    border:1px solid #F5F5F5;
                    border-radius: 10px;
                    margin-bottom: 22px;
                    &:hover{
                        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
                    }
                }
            }
            
        }
        /deep/ .ivu-carousel-active{
            button{
                width: 30px;
                height: 4px;
                background: #FFD800 !important;
                border-radius: 3px;
            }
        }
        /deep/ .ivu-carousel-dots-outside{
            margin-top: 20px;
        }
    }
    /*//下载取证宝app*/
    .model_qzb_box {
        /deep/ .ivu-modal-body{
            padding:0;
        }
    }
    .model_box{
        display: flex;
        .model_box_left{
            width: 506px;
            height: 577px;
            background: #F9F9F9;
            border-radius: 15px 0px 0px 15px;
            img{
                width: 394px;
                height: 564px;
                display: block;
                margin: 6px 56px;
            }
        }
        .model_box_right{
            flex:1;
            padding:96px 70px 0 95px;
            box-sizing: border-box;
            .right_top{
                display: flex;
                margin-bottom:84px;
                &>img{
                    width: 106px;
                    height:106px;
                    margin-right:28px;
                }
                ul{
                    flex: 1;
                    li:nth-of-type(1){
                        font-size: 24px;
                        font-weight: 800;
                        font-family:SourceHanSansCN;
                        color: #333333;
                        line-height: 36px;
                    }
                    li:nth-of-type(2){
                        font-size: 14px;
                        color: #999999;
                        line-height: 28px;
                    }
                }
            }
            .right_btm{
                display: flex;
                .right_btm_left{
                    width: 201px;
                    height: 201px;
                    background: #FFFFFF;
                    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.12);
                    border-radius: 8px;
                    margin-right:60px;
                    img{
                        width: 186px;
                        height:186px;
                        display: block;
                        margin: 8px 7px 7px 8px;
                    }
                }
                .right_btm_right{
                    flex: 1;
                    .btm_load{
                        width: 201px;
                        height: 52px;
                        background: #333333;
                        border-radius: 12px;
                        font-size: 16px;
                        color: #FFFFFF;
                        line-height: 52px;
                        display:flex;
                        justify-content: center;
                        align-items: center;
                        img{
                            width: 30px;
                            height: 30px;
                            display: inline-block;
                            margin-right:14px;
                        }
                    }
                    li:last-child{
                        font-size: 14px;
                        color: #999999;
                        line-height: 28px;
                        margin-top: 23px;
                    }
                }
            }
        }
    }
    
ul{
    li{
        list-style: none;
    }
}
</style>